module.exports = __webpack_public_path__ + "media/testimonials/property-1-78cfa6ec.jpg";